<template>
  <div>
    <router-view />
  </div>
</template>
<style>
#app {
  font-family: "KrutiDev", Avenir, Helvetica, Arial, sans-serif;
}
@font-face {
  font-family: "Kruti Dev";
  size-adjust: 150%;
  src: local("Kruti Dev"), url("./assets/fonts/Kruti_Dev_10.TTF") format("truetype");
}
</style>
